import React, { useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { BrowserRouter, StaticRouter } from 'react-router-dom';

import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { pageViewComposer } from '@bibliocommons/analytics-event-composers';
import { useRouter } from '@bibliocommons/utils-routing';
import Context from '@bibliocommons/context';
import { removeSessionStorageItem } from '@bibliocommons/utils-storage';

import { trackPageView } from 'app/actions/AnalyticsGa4Actions';
import routes from './routes';

const Router = __SERVER__ ? StaticRouter : BrowserRouter;

export function Routes() {
  const { location } = useRouter();
  const { backToLinkEnabled, hydrated } = useContext(Context);
  const dispatch = useDispatch();

  useEffect(() => {
    let bibId = null;

    // Send page view events on page load and everytime the location changes.
    BCGoogleAnalyticsUtils.pageView(`${location.pathname}${location.search}`);
    sendAnalyticsEvents(pageViewComposer.composePageViewEvent());

    if (location.pathname.startsWith('/v2/record/')) {
      bibId = /^\/v2\/record\/([^/]+)\/?/.exec(location.pathname)?.[1] ?? null;
    }

    dispatch(trackPageView({ bibId }));

    // Update the active header nav everytime the location changes
    if (window.BCHeaderPublic) {
      window.BCHeaderPublic('setActiveNavItem');
    }
  }, [dispatch, location]);

  useEffect(() => {
    if (!backToLinkEnabled && hydrated) {
      removeSessionStorageItem('backToLink');
    }
  }, [backToLinkEnabled, hydrated]);

  return routes;
}

export default function ApplicationRouter(props) {
  return (
    <Router {...props}>
      <Routes />
    </Router>
  );
}

ApplicationRouter.propTypes = {
  location: PropTypes.string
};
